import * as svg from "../../../assets/lock-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const LockIcon = iconBuilder(svg, "LockIcon", "0 0 12 12");
